import { useEffect, useState, useContext, useRef} from 'react'
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import './css/Cart.css'

import CartList from "../components/CartList";
import { AppContext } from "../../Context";
import Fetch, { allCartPrice, Loader } from "../inc/Fetch";




export default function Cart() {
	
	const { t } = useTranslation();
	const location = useLocation();
	const navigate = useNavigate();

	const {cartData, siteData, user, successData, Referrer} = useContext(AppContext); 
	const [cart, setcart] = cartData;
	const [siteInfo, setsiteInfo] = siteData;
	const [userinfo, setuserinfo] = user;
	const [success, setsuccess] = successData;
	const [referrer, setreferrer] = Referrer;

	const [total, settotal] = useState({});
	const [loader, setloader] = useState(false);
	
	
	async function submit() {

		setloader(true);
		let res = await Fetch("customers/saveCart", { cart:cart });

		if (res?.success?._id) {
			navigate(-1);

			localStorage.removeItem("cart");
			setcart([]);

			setTimeout(() => {
				navigate("/thanks", { state: { previousLocation: { pathname:"/" }, order: res?.success } });

				setloader(false);
			}, 300);
			
		} else {
			if (res?.error == "login") {
				navigate("/login", { state: {previousLocation: { pathname:"/"} } });
			} else if (res?.error == "new_customer") {
				navigate("/NoUser", {replace:true, state: {previousLocation: { pathname:"/"}} });
			} else {

				setsuccess({ error: true, short:t("error",  { returnObjects: true })[res?.error] });
			}
			setloader(false);
		}
		
	}

	async function loadTotal() {
		let res = await allCartPrice(cart, { discount:userinfo?.settings?.discount, tax:siteInfo?.settings?.tax }, siteInfo?.settings?.taxes_included?.val);

		settotal(res);
	}
	

	useEffect(() => {
		if (cart?.length) {
			
			loadTotal();
		}

	}, [cart, userinfo?.settings]);

	useEffect(() => {

		
		function handleNavigation(e) {
			
			if(e?.target?.className == 'cartBox') {
				if (referrer?.length <= 1) {
					navigate("/");
				} else {
					navigate(-1);
				}
			}
		}

        window.addEventListener("click", handleNavigation);
        return () => {
            window.removeEventListener("click", handleNavigation);
        };

    }, []);


	return (
		<>
			{loader && <Loader />}
			<div className='cartBox'>
                <div className='cartInsideBox'>
					<strong>{t("my_cart")}</strong>

					<div className='cartScrollOutBox'>
						<div className='cartScrollBox'>
							{cart?.map((v, k) => {
	
								return (
									<>
										<CartList v={v} key={k} />
									</>
								);
							})}

							{cart?.length ? "" : <div className='noData'>{t("cart_empty_text")}</div>}
							

						</div>
					</div>

					{cart?.length ? <div className='cartInfoBox'>
						
						{siteInfo?.settings?.show_prices?.val == 1 || (siteInfo?.settings?.show_prices?.val == 0 && userinfo?._id) ? 
						<>
							<b>{t("cart_summery")}</b>
							<table>
								<tr>
									<td>{t("price")}</td>
									<td></td>
									<td>{total?.subtotal} <span>{global?.currency}</span></td>
								</tr>
								{userinfo?.settings?.discount ? <tr>
									<td>{t("cart_discount")}</td>
									<td>{userinfo?.settings?.discount}%</td>
									<td>{total?.discount} <span>{global?.currency}</span></td>
								</tr>: false}
								{siteInfo?.settings?.tax ? <tr>
									<td>{t("cart_tax")}</td>
									<td>{siteInfo?.settings?.tax}%</td>
									<td>{total?.tax} <span>{global?.currency}</span></td>
								</tr>
								: false}
								<tr className='total'> 
									<td>{t("cart_total")}</td>
									<td></td>
									<td>{total?.total} <span>{global?.currency}</span></td>
								</tr>
							</table>
						</>
						: false}

						<button onClick={submit} className='btn'>{t("cart_send")}</button>
					</div>: false}

					

                </div>
            </div>
		</>
	)
}
